export default __webpack_public_path__ + "static/media/nft14.3e5c9954.png";